import { GetContainersByReceivedFromParams } from 'modules/global/adapters/crpAPI';

export const declineReleaseRightKeys = {
  root: ['decline-releaseright'] as const,
  containersForUpdateRoot: () =>
    [...declineReleaseRightKeys.root, 'containers-for-update'] as const,
  containersForUpdate: (receivedFromParams: GetContainersByReceivedFromParams) =>
    [...declineReleaseRightKeys.containersForUpdateRoot(), receivedFromParams] as const,
  postContainersDecline: () =>
    [...declineReleaseRightKeys.root, 'post-containers-decline-releaseright'] as const,
  getTerminals: () => [...declineReleaseRightKeys.root, 'get-terminals'] as const,
  getPendingContainersForReleaseRightAction: () => [
    ...declineReleaseRightKeys.containersForUpdateRoot(),
    'get-pending-containers',
  ],
};
